import { Controller } from "@hotwired/stimulus"

// An idea's sheet (Ideas page): the row opens a native <dialog> with what is included and how
// it works. Backdrop click and Escape close it; the buttons inside are ordinary forms.
export default class extends Controller {
  static targets = ["dialog"]

  open() {
    if (!this.dialogTarget.open) this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  backdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
